import call from './call';

// The personalization insights dashboard (CONTEXT.md "Insights"). Admin
// and editor only. Every aggregate takes a `days` window, clamped 1-365
// server side; ingestion health is served live, the rest from a 15-minute
// cache keyed on the same window.
const BASE = '/api/insights';

// { window_days, events_per_day: [{day, events, active_users}],
//   window_events, last_received_at }
export const fetchIngestionHealth = (token, days) => call(
    `${BASE}/personalization/health?days=${days}`, token, { method: 'GET' },
);

// { window_days, slot_performance: {reason: {...}},
//   category_engagement: {category_id: {event_type: count}} }
export const fetchTuning = (token, days) => call(
    `${BASE}/personalization/tuning?days=${days}`, token, { method: 'GET' },
);

// { profile, arm, feed_preview, recent_events, recent_servings }
export const inspectUser = (token, userId) => call(
    `${BASE}/personalization/user?user_id=${encodeURIComponent(userId)}`,
    token, { method: 'GET' },
);
